import {
  CaretLeft,
  CaretRight,
  Gear,
  Power,
  ShoppingCartSimple,
} from "@phosphor-icons/react";
import { ActionButton } from "../models/global/Types";

const iconSizeActionButton = 40;
export const isInDevMode = false;
export const SERVERURL = isInDevMode
  ? "http://84.195.165.7:5000/api"
  : "https://backend.selico.be/api";
export const defaultEmail = "info@selico.be";

export const actionButtons: ActionButton[] = [
  {
    icon: <CaretLeft size={iconSizeActionButton} weight="bold" />,
    altIcon: <CaretRight size={iconSizeActionButton} weight="bold" />,
    path: "/",
  },
  {
    icon: <Gear size={iconSizeActionButton} weight="bold" />,
    path: "/settings",
  },
  {
    icon: <ShoppingCartSimple size={iconSizeActionButton} weight="bold" />,
    path: "/shopping",
  },
  {
    icon: <Power size={iconSizeActionButton} weight="bold" />,
    path: "/redirect/logout",
  },
];


export const companyInfo = {
  name: "Selico bv",
  address: "Halensebaan 155A",
  city: "3390 Tielt-Winge",
  country: "België",
  vat: "BE 0778.887.729",
  email: "info@selico.be",
  phone: "+32 468/15.71.56",
  peppolId: "0208:0778887729"
};
